import { createReducer, on } from '@ngrx/store';
import { Product } from 'src/typings';
import {
  addToCart,
  clearCart,
  removeFromCart,
  updateCart,
  updateProductInCart
} from '../actions/cart.actions';

function readInitialCartState(): { product: Product; quan: number; retail: number }[] {
  try {
    const raw = window.localStorage.getItem('cart');
    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    window.localStorage.setItem('cart', JSON.stringify([]));
    return [];
  }
}

export const initialState: { product: Product; quan: number; retail: number }[] = readInitialCartState();

export const cartReducer = createReducer(
  initialState,
  on(updateCart, (_state, payload) => {
    return payload.payload;
  }),
  on(addToCart, (_state, payload) => {
    const neWState = [
      ..._state,
      { product: payload.payload, quan: 1, retail: payload.payload.retail }
    ];
    window.localStorage.setItem('cart', JSON.stringify(neWState));
    setTimeout(() => {
      window.dispatchEvent(new Event('storage'));
    }, 0);
    return neWState;
  }),
  on(removeFromCart, (_state, payload) => {
    const neWState = [..._state].filter((row) => row.product.id !== payload.payload.id);
    window.localStorage.setItem('cart', JSON.stringify(neWState));
    setTimeout(() => {
      window.dispatchEvent(new Event('storage'));
    }, 0);
    return neWState;
  }),
  on(clearCart, () => {
    window.localStorage.setItem('cart', JSON.stringify([]));
    setTimeout(() => {
      window.dispatchEvent(new Event('storage'));
    }, 0);
    return [];
  }),
  on(updateProductInCart, (_state, payload) => {
    const neWState: { product: Product; quan: number; retail: number }[] = [..._state];
    const findIndex = neWState.findIndex((row) => row.product.id === payload.payload.id);
    neWState.splice(findIndex, 1, {
      product: payload.payload,
      quan: Number(payload.quan),
      retail: Number(payload.retail || neWState[findIndex].retail)
    });
    window.localStorage.setItem('cart', JSON.stringify(neWState));
    setTimeout(() => {
      window.dispatchEvent(new Event('storage'));
    }, 0);
    return neWState;
  })
);
